import { render, staticRenderFns } from "./archivesDetails.vue?vue&type=template&id=614cf398&scoped=true&"
import script from "./archivesDetails.vue?vue&type=script&lang=js&"
export * from "./archivesDetails.vue?vue&type=script&lang=js&"
import style0 from "./archivesDetails.vue?vue&type=style&index=0&id=614cf398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614cf398",
  null
  
)

component.options.__file = "archivesDetails.vue"
export default component.exports